import { useQuery } from '@tanstack/react-query'

import { QueryKey } from 'modules/Monitoring/consts/query/queryKey'

import { getUsers } from './requests'

export const useUsersQuery = () => {
  return useQuery({
    queryKey: [QueryKey.GetUsers],
    queryFn: () => getUsers(),
  })
}
